const baseUrl = "/v1/admin/industry";
const baseUrl2 = "/v1/admin";

export const apiUrls = {
  list: `${baseUrl}`,
  create: `${baseUrl}/create`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
  getIndustryWizeData: `${baseUrl2}/solar-dropdown-data`,
  categoryList: `${baseUrl}/category`,
};
